export enum ScenarioID {
  Recommended = "recommended",
  Current = "current",
}

export enum Entitlement {
  LifeInsurance = "FormeLifeInsuranceBlock",
  StudentLoans = "FormeStudentLoansBlock",
  Retirement = "FormeRetirementBlock",
  PlayZone = "PlayZone",
  WhatAreYouAfraidOf = "WhatAreYouAfraidOf",
}

export interface SamlAttribute {
  "saml:Attribute": {
    "@_Name": string;
  };
}
